import GradeFeeDetail from "@/controllers/grade_fee/grade-fee-detail";

export default {
    extends: GradeFeeDetail,
};
